/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MailParamsContactTemplateData } from '../../models/mail-params-contact-template-data';
import { ResponseObject } from '../../models/response-object';

export interface SendContactMail$Params {
      body: MailParamsContactTemplateData
}

export function sendContactMail(http: HttpClient, rootUrl: string, params: SendContactMail$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseObject>> {
  const rb = new RequestBuilder(rootUrl, sendContactMail.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseObject>;
    })
  );
}

sendContactMail.PATH = '/sendMail/contact';
